import React, { useEffect, useState } from 'react';
import * as styles from './businessRegistration.styles';
import icon from '../../../assets/BusinessInfoIcon.png';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import FileUploadCard from '../../../components/FileUploadCard/FileUploadCard';
import FileInputWithList from '../../../components/FileInput/FileInput';
import { Button, Datepicker, Label, Spinner } from 'flowbite-react';
import { FaArrowRight, FaPlusCircle } from 'react-icons/fa';
import { MdAddCircle } from 'react-icons/md'
import CustomModal from '../../../components/Modal/CustomModal';
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import { useNavigate } from 'react-router-dom';
import modalIcon from '../../../assets/shareholdersIcon.png'
import { serialize } from 'object-to-formdata';

interface StakeHolders {
    firstName: string,
    lastName: string,
    gender: string,
    dateofBirth: string,
    mobileNumber: string,
    bvn: string
}

interface BusinessRegistrationInputs {
    businessClass: string;
    tin: string;
    registrationNumber: string;
    certOfIncorporation: File | null;
    certOfIncorporationUrl?: string;
    memoOfAssociation: File | null;
    memoOfAssociationUrl?: string;
    particularsofDirectors: File | null;
    particularsofDirectorsUrl?: string;
    statementOfShares: File | null;
    statementOfSharesUrl?: string;
    proofOfAddress: File | null;
    proofOfAddressUrl?: string;
    operatingLicense: File | null;
    operatingLicenseUrl?: string;
    directorsIdentification: File | null;
    directorsIdentificationUrl?: string;
}

const BusinessRegistration = ({changeCard}:any) => {
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState<boolean>(false)
    const [stakeHolders, setStakeHolders] = useState<any[]>([])
    const [businessClasses, setBusinessClasses] = useState<any[]>([])
    const [stakeHolderDetails, setStakeHolderDetails] = useState({
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        phoneNumber: '',
        bvn: ''
    })
    const [registrationData, setRegistrationData] = useState<any>(null)
    const [formData, setFormData] = useState<BusinessRegistrationInputs>({
        businessClass: '',
        tin: '',
        registrationNumber: '',
        certOfIncorporation: null,
        certOfIncorporationUrl: '',
        memoOfAssociation: null,
        memoOfAssociationUrl: '',
        particularsofDirectors: null,
        particularsofDirectorsUrl: '',
        statementOfShares: null,
        statementOfSharesUrl: '',
        proofOfAddress: null,
        proofOfAddressUrl: '',
        operatingLicense: null,
        operatingLicenseUrl: '',
        directorsIdentification: null,
        directorsIdentificationUrl: ''
    })

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        const fetchData = async () => {
            await getStakeHolders()
            await getBusinessClasses()
            await fetchBusinessRegistrationData()
        }

        fetchData()
    }, [])

    useEffect(() => {
        if (registrationData) {
            // Map main registration documents
            setFormData({
                ...formData,
                businessClass: registrationData?.registrationDocument?.businessClassId ?? "",
                tin: registrationData?.registrationDocument?.taxIdNumber ?? "",
                registrationNumber: registrationData?.registrationDocument?.registrationNumber ?? "",
                certOfIncorporationUrl: registrationData?.registrationDocument?.certOfIncorporation ?? "",
                memoOfAssociationUrl: registrationData?.registrationDocument?.memoOfAssociation ?? "",
                statementOfSharesUrl: registrationData?.registrationDocument?.statementOfShares ?? "",
                operatingLicenseUrl: registrationData?.registrationDocument?.operationLicense ?? "",
            });

            // Map other documents from the array
            registrationData.otherDocuments?.forEach((doc: any) => {
                switch (doc.documentName) {
                    case 'DirectorIdentification':
                        setFormData(prev => ({ ...prev, directorsIdentificationUrl: doc.value }));
                        break;
                    case 'ProofOfAddress':
                        setFormData(prev => ({ ...prev, proofOfAddressUrl: doc.value }));
                        break;
                    default:
                        break;
                }
            });
        }
    }, [registrationData])

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setStakeHolderDetails({ ...stakeHolderDetails, [name]: value });
    };
    const handleFormInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileInputChange = (file: File | null, fileType: string) => {
        setFormData({
            ...formData,
            [fileType]: file,
        });
    };

    const saveStakeHolders = async () => {
        let payload: StakeHolders = {
            firstName: stakeHolderDetails.firstName,
            lastName: stakeHolderDetails.lastName,
            gender: stakeHolderDetails.gender,
            dateofBirth: stakeHolderDetails.dateOfBirth,
            mobileNumber: stakeHolderDetails.phoneNumber,
            bvn: stakeHolderDetails.bvn
        }
        try {
            const response = await client.post("/subsidiary/dashboard/onboarding/stakeholder/add", payload);
            if (response.data.status === "success") {
                console.log(response);

                showToast(response.data.message, "success")
                //navigate('/business/onboarding/kyc/business-registration')
            } else {
                console.log(response.data.message);
                showToast(response.data.message, "error")
            }
        } catch (err: any) {
            console.error('Error saving stakeholder details', err);
            showToast(err.response.data.message, "error")
        }
    }

    const fetchBusinessRegistrationData = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/onboarding/business/registration/view';
            const response = await client.get(`${apiUrl}`);
            console.log(response);

            setRegistrationData(response.data.data);
            const message = response?.data?.message;
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }
    const getStakeHolders = async () => {
        try {
            const response = await client.get("/subsidiary/dashboard/onboarding/stakeholder/view");
            if (response.data.status === "success") {
                setStakeHolders(response.data.data)
            } else {
                console.log(response.data.message);
            }
        } catch (err: any) {
            console.error('Error saving stakeholder details', err);
            showToast(err.response.data.message, "error")
        }
    }
    const getBusinessClasses = async () => {
        try {
            const response = await client.get("/subsidiary/dashboard/business/classes");
            if (response.data.status === "success") {
                setBusinessClasses(response.data.data)
                // showToast(response.data.message,"success")
                //navigate('/business/onboarding/kyc/business-registration')
            } else {
                console.log(response.data.message);
                // showToast(response.data.message,"error")
            }
        } catch (err: any) {
            console.error('Error fetching business classes', err);
            showToast(err.response.data.message, "error")
        }
    }

    const handleSubmit = async () => {
        // const dataToSend = new FormData();
        // dataToSend.append("BusinesClassId", formData.businessClassId.toString())
        // dataToSend.append("TaxIdNumber", formData.tin)
        // dataToSend.append("RegistrationNumber", formData.registrationNumber)
        // if (formData.certOfIncorporation) { dataToSend.append("CertOfIncorporation", formData?.certOfIncorporation) }
        // if (formData.memoOfAssociation) dataToSend.append("MemoOfAssociation", formData.memoOfAssociation)
        // if (formData.particularsofDirectors) dataToSend.append("ParticularsOfDirectors", formData.particularsofDirectors)
        // if (formData.statementOfShares) dataToSend.append("StatementOfShares", formData.statementOfShares)
        // if (formData.proofOfAddress) dataToSend.append("ProofOfAddress", formData.proofOfAddress)
        // if (formData.directorsIdentification) dataToSend.append("DirectorsIdentification", formData.directorsIdentification)
        // if (formData.operatingLicense) dataToSend.append("OperatingLicense", formData.operatingLicense)
        // console.log(dataToSend);
        const payload = {
            BusinessClassId: formData.businessClass,
            TaxIdNumber: formData.tin,
            RegistrationNumber: formData.registrationNumber,
            CertOfIncorporation: formData.certOfIncorporation,
            MemoOfAssociation: formData.memoOfAssociation,
            ParticularsOfDirectors: formData.particularsofDirectors,
            StatementOfShares: formData.statementOfShares,
            ProofOfAddress: formData.proofOfAddress,
            DirectorsIdentification: formData.directorsIdentification,
            OperatingLicense: formData.operatingLicense
        };

        const dataToSend = serialize(payload)
        setLoading(true)
        try {
            const response = await client.post("/subsidiary/dashboard/onboarding/business/registration/add-or-update", dataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status === "success") {
                console.log(response);

                showToast(response.data.message, "success")
                navigate('/business/onboarding/kyc/bank-details')
                window.location.reload()
                localStorage.setItem('activeCard','Bank Details')
                // navigate('/dashboard')
            } else {
                console.log(response.data.message);
                showToast(response.data.message, "error")
            }
        } catch (err: any) {
            console.error('Error saving business details', err);
            showToast(err.response.data.message, "error")
        }
        finally {
            setLoading(false)
        }


    }

    const removeStakeHolder = async (id: number) => {
        try {
            const response = await client.delete(`/subsidiary/dashboard/onboarding/stakeholder/delete/${id}`);
            if (response.data.status === "success") {

                showToast(response.data.message, "success")
                //navigate('/business/onboarding/kyc/business-registration')
            } else {
                console.log(response.data.message);
                // showToast(response.data.message,"error")
            }
        } catch (err: any) {
            console.error('Error saving stakeholder details', err);
            showToast(err.response.data.message, "error")
        }
    }
    return (
        <div className={styles.container}>
            <div className={styles.iconContainer}>
                <img src={icon} alt="Business Info Icon" />
            </div>
            <div className={styles.headerContainer}>
                <p className={styles.headerTitle}>Business Registration</p>
                <p className={styles.headerSubTitle}>
                    Kindly provide us with some business information to get your dashboard ready
                </p>
            </div>
            <div>
                <div>
                    <CustomSelectInput className={styles.selectInputLabel} label='Business Class' items={businessClasses} value={formData.businessClass} displayKey='name' valueKey='id' onChange={(value) => setFormData({ ...formData, businessClass: value })} />
                </div>
                <div>
                    <CustomInput label='Tax Identification Number' value={formData.tin} name='tin' onChange={handleFormInputChange} />
                </div>
                <div>
                    <CustomInput label='Registration Number' value={formData.registrationNumber} name='registrationNumber' onChange={handleFormInputChange} />
                </div>
                <p className={styles.subText}>
                    All documents must be in either .jpeg, .jpg, .png or .pdf format, with a max size of 1mb
                </p>
                <FileUploadCard 
                    label='Certificate of Incorporation' 
                    current={formData.certOfIncorporation} 
                    onChange={(file) => handleFileInputChange(file, 'certOfIncorporation')} 
                />
                {formData.certOfIncorporationUrl && !formData.certOfIncorporation && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.certOfIncorporationUrl} alt='Certificate of Incorporation' className='w-full h-full object-cover' />
                    </div>
                )}
                <FileUploadCard 
                    label='Memorandum & articles of association' 
                    current={formData.memoOfAssociation}
                    onChange={(file) => handleFileInputChange(file, 'memoOfAssociation')} 
                />
                {formData.memoOfAssociationUrl && !formData.memoOfAssociation && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.memoOfAssociationUrl} alt='Memorandum & articles of association' className='w-full h-full object-cover' />
                    </div>
                )}

                {/* <FileInputWithList /> */}
                <div className='my-2'>
                    <p className='font-semibold text-sm'>Add Shareholders</p>
                    <div className='border p-2 flex'>
                        {stakeHolders.map((stakeHolder, index) => (
                            <div key={index} className='flex items-center gap-2 border rounded-md bg-gray-50 mx-2 p-2'>
                                <span>{stakeHolder.firstName} {stakeHolder.lastName}</span>
                                <button className='text-red-600 font-bold' onClick={() => removeStakeHolder(stakeHolder.id)}>x</button>
                            </div>
                        ))}
                        <span className='flex items-center text-green-800 text-sm gap-1 ml-auto' onClick={() => {
                            setShowModal(true); console.log(showModal);
                        }}><MdAddCircle color='green' />Add new</span>
                        {showModal && <CustomModal icon={modalIcon} dismissible={true} show={showModal} onClose={() => setShowModal(false)}

                        >
                            <div>
                                <img src={icon} className='my-3' />
                                <div className='my-3'>
                                    <p className='text-xl font-bold'>Add shareholders with over 5% equity</p>
                                    <p className='text-sm'>Kindly fill in the information needed</p>
                                </div>
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                                <CustomInput label='First name' name='firstName' value={stakeHolderDetails.firstName} onChange={handleInputChange} />
                                <CustomInput label='Last name' name='lastName' value={stakeHolderDetails.lastName} onChange={handleInputChange} />
                                <CustomSelectInput label='Gender' name='gender' items={["Male", "Female"]} onChange={(value) => setStakeHolderDetails({ ...stakeHolderDetails, gender: value })} />
                                <div>
                                    <Label htmlFor='dob' value='Date of birth' />
                                    <Datepicker
                                        id='dob'
                                        value={stakeHolderDetails.dateOfBirth}
                                        maxDate={new Date()}
                                        onSelectedDateChanged={(date) => { setStakeHolderDetails({ ...stakeHolderDetails, dateOfBirth: date.toISOString() }); }}
                                    />
                                </div>
                                <CustomInput label='Phone number' placeholder='+234' name='phoneNumber' value={stakeHolderDetails.phoneNumber} onChange={handleInputChange} />
                                <CustomInput label='BVN' name='bvn' value={stakeHolderDetails.bvn} onChange={handleInputChange} />
                            </div>
                            <div className='flex gap-2 mb-4'>
                                <Button className='border border-gray-500 bg-white text-black w-1/3 hover:bg-custom-button-green' outline>Cancel</Button>
                                <Button className='bg-custom-button-green text-black w-2/3 hover:bg-custom-button-green' onClick={() => saveStakeHolders()}>Save</Button>
                            </div>
                        </CustomModal>}
                    </div>
                </div>
                <FileUploadCard 
                    label='Particulars of Directors (Optional)' 
                    current={formData.particularsofDirectors}
                    onChange={(file) => handleFileInputChange(file, 'particularsofDirectors')} 
                />
                {formData.particularsofDirectorsUrl && !formData.particularsofDirectors && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.particularsofDirectorsUrl} alt='Particulars of Directors' className='w-full h-full object-cover' />
                    </div>
                )}
                <FileUploadCard 
                    label='Statement of return on allotment of shares (optional)' 
                    current={formData.statementOfShares}
                    onChange={(file) => handleFileInputChange(file, 'statementOfShares')} 
                />
                {formData.statementOfSharesUrl && !formData.statementOfShares && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.statementOfSharesUrl} alt='Statement of shares' className='w-full h-full object-cover' />
                    </div>
                )}
                <FileUploadCard 
                    label='Proof of address' 
                    current={formData.proofOfAddress}
                    onChange={(file) => handleFileInputChange(file, 'proofOfAddress')} 
                />
                {formData.proofOfAddressUrl && !formData.proofOfAddress && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.proofOfAddressUrl} alt='Proof of address' className='w-full h-full object-cover' />
                    </div>
                )}
                <FileUploadCard 
                    label='Operating license' 
                    current={formData.operatingLicense}
                    onChange={(file) => handleFileInputChange(file, 'operatingLicense')} 
                />
                {formData.operatingLicenseUrl && !formData.operatingLicense && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.operatingLicenseUrl} alt='Operating license' className='w-full h-full object-cover' />
                    </div>
                )}
                <FileUploadCard 
                    label='Primary identification documents of all shareholders with 5% ownership and above (Merge all documents into one) - Director 1' 
                    current={formData.directorsIdentification}
                    onChange={(file) => handleFileInputChange(file, 'directorsIdentification')} 
                />
                {formData.directorsIdentificationUrl && !formData.directorsIdentification && (
                    <div className={'flex justify-center items-center mx-auto h-28 w-28 rounded-full mt-2'}>
                        <img src={formData.directorsIdentificationUrl} alt='Directors Identification' className='w-full h-full object-cover' />
                    </div>
                )}
            </div>
            <div className='px-4'>
                <Button onClick={() => handleSubmit()} className='w-full bg-custom-button-green'>
                    <div className='flex justify-center items-center gap-3 text-black'>
                        {loading ? <Spinner size='sm' /> : <>
                            <span>Save Details</span>
                            <FaArrowRight />
                        </>}

                    </div>

                </Button>
            </div>
        </div>
    );
};

export default BusinessRegistration;
